import { render, staticRenderFns } from "./Applies.vue?vue&type=template&id=f33b3a70&"
import script from "./Applies.vue?vue&type=script&lang=js&"
export * from "./Applies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports